module.exports = __webpack_public_path__ + "img/damoxing.888343c4.png";